var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscDrive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 112C176.5 112 112 176.5 112 256S176.5 400 256 400S400 335.5 400 256S335.5 112 256 112ZM256 288C238.375 288 224 273.625 224 256S238.375 224 256 224C273.625 224 288 238.375 288 256S273.625 288 256 288ZM488 432H480V96C480 60.654 451.346 32 416 32H96C60.654 32 32 60.654 32 96V432H24C10.745 432 0 442.745 0 456V456C0 469.255 10.745 480 24 480H488C501.255 480 512 469.255 512 456V456C512 442.745 501.255 432 488 432ZM432 432H80V96C80 87.125 87.125 80 96 80H416C424.875 80 432 87.125 432 96V432Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscDrive);
export default __webpack_public_path__ + "static/media/disc-drive.dbcde67f2d3c25504733f532c3ef29d9.svg";
export { ForwardRef as ReactComponent };